export default {
  detail: 'chi tiết merchant',
  backpage: 'trở về trang trước',
  basic: 'thông tin merchant',
  agency: 'đại lý',
  merchantkey: 'merchant key',
  indetails: 'thông tin merchant',
  merchantcode: 'mã xác minh merchant',
  scan: 'quét mã qr lấy mã xác minh',
  authcode: 'vui lòng nhập mã xác minh',
  codenull: 'mã xác minh không được bỏ trống',
  label: {
    amount: 'Số tiền',
    merchatNo: 'Tài khoản merchant',
    walletTypeTransferIn: 'loại ví chuyển vào',
    walletTypeTransferOut: 'loại ví chuyển ra',
    usdt_qr: 'USDT',
    walletTile: 'chi tiết ví tiền',
    all: 'Tổng Ví',
    kou: 'Khấu trừ thủ công',
    recharge: 'Nạp tiền thủ công',
  },
  rules: {
    amount: {
      required: 'Số tiền không được để trống',
      type: 'Số tiền phải là định dạng số',
      typeinteger: 'Số tiền phải là số và phải là số nguyên',
      max: 'Số tiền phải lớn hơn số dư'
    },
    remark: {
      required: 'Chú thích không được để trống'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/merchantdetails.js